<script>
    import axios from 'axios'
    import AppMixin from './../../../mixins/AppMixin'
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import InputNumber from "primevue/inputnumber";
    import Divider from "primevue/divider";
    import RadioButton from "primevue/radiobutton";

    export default {
        mixins: [AppMixin],
        data() {
            return {
                loading: false,
                error: null,
                model: {}
            }
        },
        props: ["name", "uid", "type"],
        methods: {
            save() {
                let self = this;

                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: self.model,
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.error = null
            },
            onOpen() {
                this.model = {
                    conditionOr: true,
                    targetNode: -2,
                };
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/clustering/' + this.uid + '/' +this.type + '/filter' ;
            },
            btnModalLabel(){
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            filterLabel(){
                return this.type === 'import' ? this.$t('lang.cluster.add_keys_run') : this.$t('lang.cluster.delete_keys_run');
            },
            resultStr() {
                let result = [], interResult = [];

                let config = {
                    [this.$t('lang.main.f_ws_label')]: [
                        {condition: '>=', field: 'wsFrom'}, {condition: '<=', field: 'wsTo'},
                    ],
                    [this.$t('lang.main.f_wsk_label')]: [
                        {condition: '>=', field: 'wskFrom'}, {condition: '<=', field: 'wskTo'},
                    ],
                    [this.$t('lang.main.f_superwsk_label')]: [
                        {condition: '>=', field: 'superwskFrom'}, {condition: '<=', field: 'superwskTo'},
                    ]
                };

                for (let prop in config) {
                    config[prop].forEach((c) => {
                        if(this.model.hasOwnProperty(c.field) && this.model[c.field] !== ""){
                            interResult.push(prop + " " + c.condition + " " + this.model[c.field]);
                        }
                    });

                    if(interResult.length > 0){
                        result.push("(" + interResult.join(" " + this.$t('lang.main.filter.and') + " ") + ")");
                        interResult = [];
                    }

                }


                if(result.length === 0){
                    return null;
                }

                return "(" + result.join(this.model.conditionOr ? (" " + this.$t('lang.main.filter.or') + " ") : (" " + this.$t('lang.main.filter.and') + " ")) + ")"
            }

        },
        components: {
            AdaptersDialog,
            InputNumber,
            Divider,
            RadioButton,
        },
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.cluster.delete_key_by_filter')"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="btnModalLabel"
    >
        <template #content>
            <p class="pt-0">{{ $t('lang.main.f_rules') }}</p>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wsFrom">
                            {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_from')}}
                        </label>
                        <InputNumber v-model.number="model.wsFrom" inputId="wsFrom" :min="0" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wsTo">
                            {{this.isGoogleGny ? $t('lang.main.f_frequency_label') : $t('lang.main.f_ws_label')}} {{$t('lang.main.f_to')}}
                        </label>
                        <InputNumber v-model.number="model.wsTo" inputId="wsTo" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wskFrom">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_from')}}</label>
                        <InputNumber v-model.number="model.wskFrom" inputId="wskFrom" :min="0" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="wskTo">{{$t('lang.main.f_wsk_label')}} {{$t('lang.main.f_to')}}</label>
                        <InputNumber v-model.number="model.wskTo" inputId="wskTo" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field mb-0">
                        <label for="wskFrom">{{$t('lang.main.f_superwsk_label')}} {{$t('lang.main.f_from')}}</label>
                        <InputNumber v-model.number="model.superwskFrom" inputId="superwskFrom" :min="0" />
                    </div>
                </div>
                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="wskTo">{{$t('lang.main.f_superwsk_label')}} {{$t('lang.main.f_to')}}</label>
                        <InputNumber v-model.number="model.superwskTo" inputId="superwskTo" />
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col">
                    <div class="field">
                        <label>{{filterLabel}}</label>
                        <div class="formgroup-inline">
                            <div class="field-radiobutton">
                                <RadioButton v-model="model.conditionOr" :value="false" inputId="conditionAnd" />
                                <label for="conditionAnd">{{ $t('lang.main.f_rule_and') }}</label>
                            </div>
                            <div class="field-radiobutton">
                                <RadioButton v-model="model.conditionOr" :value="true" inputId="conditionOr" />
                                <label for="conditionOr">{{ $t('lang.main.f_rule_or') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="resultStr">
                <div class="grid">
                    <div class="col">
                        <code>{{ resultStr }}</code>
                    </div>
                </div>
            </template>
            <Divider />
            <div class="formgroup-inline">
                <label>{{ $t('lang.cluster.select_folder') }}</label>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_deleted"
                        name="targetNode"
                        :value="-2"
                    />
                    <label for="f_deleted">{{ $t('lang.cluster.f_deleted') }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton
                        v-model="model.targetNode"
                        inputId="f_unallocated"
                        name="targetNode"
                        :value="-1"
                    />
                    <label for="f_unallocated">{{ $t('lang.cluster.f_unallocated') }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
